import React from 'react';

import AvailabilityStore from "../stores/AvailabilityStore";
import AvailabilityActions from "../actions/AvailabilityActions";

import Geosuggest from './GeoSuggest/Geosuggest.jsx';


function getSuggestionValue(suggestion) { // when suggestion selected, this function tells
  return suggestion.text;                 // what should be the value of the input
}

function renderSuggestion(suggestion) {
  return (
    <span>{suggestion.text}</span>
  );
}

var Suggestions = React.createClass({
  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
    if (this.myTextInput !== null && (this.state.store.getIn(['input_address', 'verified']) || this.state.store.get('suggestions_confirm_dismissed'))) {
      AvailabilityActions.updateGeoSuggest.defer(this.myTextInput, this.state.store.getIn(['input_address', 'streetAddress']));
    }

  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    if (this.myTextInput !== null && (state.getIn(['input_address', 'verified']) || state.get('suggestions_confirm_dismissed'))) {
      AvailabilityActions.updateGeoSuggest.defer(this.myTextInput, state.getIn(['input_address', 'streetAddress']));
    }
  },

  streetAddressChange(value) {
    AvailabilityActions.updateStreetAddress(value);
  },

  streetAddressBlur(event) {
    AvailabilityActions.verifyInput(this.state.store.toJS());
  },

  streetAddressSuggestionSelected(suggest) {
    AvailabilityActions.suggestionSelected(suggest);
    AvailabilityActions.verifySuggestion(suggest);
  },

  render() {
    var sclass = this;
      return <Geosuggest 
        placeholder="Street Address"
        id="street_address"
        inputClassName="form-control"
        onChange={this.streetAddressChange}
        onBlur={this.streetAddressBlur}
        onSuggestSelect={this.streetAddressSuggestionSelected}
        ignoreTab={true}
        ref={function(input) {
          sclass.myTextInput = input;
        }}
      />;
  }
});

export default  Suggestions;